import { render, staticRenderFns } from "./AppDataState.vue?vue&type=template&id=0057a50a"
import script from "./AppDataState.vue?vue&type=script&lang=js"
export * from "./AppDataState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports